/**
 * Zu einem Jahr springen.
 *
 * 995 Tauchgänge sind auf einem Telefon hundert Bildschirme. Wer den Tauchgang
 * von 2011 sucht, wischt eine Minute lang — oder er tippt auf die
 * Jahresüberschrift, die beim Blättern ohnehin oben stehen bleibt, und wählt.
 *
 * Ein Blatt und keine ausklappbare Liste: Zwölf Jahre passen auf keinen
 * Ausklapper, der über einer Liste schwebt, und die Auswahl soll dort
 * erscheinen, wo der Daumen ist.
 */

import { oeffneBlatt } from './blatt.js';

/**
 * Fragt nach einem Jahr und gibt es zurück — oder `null`, wenn abgebrochen
 * wurde.
 *
 * `jahre` kommt als Liste von `{ jahr, anzahl }` in der Reihenfolge, in der
 * die Liste sie zeigt: neueste zuerst. Die Reihenfolge wird nicht neu
 * gerechnet — im Blatt soll dieselbe Ordnung stehen wie darunter.
 */
export function frageJahr(jahre, aktuelles) {
  return oeffneBlatt({
    titel: 'Zu welchem Jahr?',
    klasse: 'jahrblatt',
    aufbauen: (schliesse) => {
      const liste = document.createElement('div');
      liste.className = 'jahrliste';
      for (const { jahr, anzahl } of jahre) {
        const knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = String(jahr) === String(aktuelles) ? 'jahrwahl aktiv' : 'jahrwahl';
        const zahl = document.createElement('span');
        zahl.className = 'jahrwahl-jahr';
        zahl.textContent = jahr ?? 'ohne Datum';
        const menge = document.createElement('span');
        menge.className = 'jahrwahl-anzahl';
        menge.textContent = anzahl === 1 ? '1 Tauchgang' : `${anzahl} Tauchgänge`;
        knopf.append(zahl, menge);
        knopf.addEventListener('click', () => schliesse(jahr));
        liste.append(knopf);
      }
      return liste;
    },
  });
}
